import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const FORMATOS_DATA = {
  PADRAO: 'dd/MM/yyyy',
  DATA_HORA: 'dd/MM/yyyy HH:mm',
  HORA: 'HH:mm',
  MES_ANO: 'MM/yyyy',
  DATA_COMPLETA: 'PPP',
  DATA_HORA_COMPLETA: 'PPPp'
};

export const formatarData = (data, formatoPersonalizado = FORMATOS_DATA.PADRAO) => {
  if (!data) return '';
  try {
    let dataObj;
    if (typeof data === 'string') {
      try {
        dataObj = parseISO(data);
      } catch {
        dataObj = new Date(data);
      }
    } else {
      dataObj = data;
    }

    if (isNaN(dataObj.getTime())) {
      console.warn('Data inválida:', data);
      return '';
    }

    return format(dataObj, formatoPersonalizado, { locale: ptBR });
  } catch (error) {
    console.error('Erro ao formatar data:', error, {
      data,
      formato: formatoPersonalizado
    });
    return '';
  }
};

export const formatarDataPagamento = (data) => {
  if (!data) return '';
  try {
    let dataObj;
    if (typeof data === 'string') {
      try {
        dataObj = parseISO(data);
      } catch {
        dataObj = new Date(data);
      }
    } else {
      dataObj = data;
    }

    if (isNaN(dataObj.getTime())) {
      console.warn('Data de pagamento inválida:', data);
      return '';
    }

    return format(dataObj, FORMATOS_DATA.DATA_HORA, { locale: ptBR });
  } catch (error) {
    console.error('Erro ao formatar data de pagamento:', error, { data });
    return '';
  }
};

/**
 * Formata um valor para o formato de moeda MZN
 * @param {number} valor - Valor a ser formatado
 * @param {string} moeda - Código da moeda (default: 'MZN')
 * @returns {string} Valor formatado como moeda
 */
export const formatarMoeda = (valor, moeda = 'MZN') => {
  if (valor === null || valor === undefined || isNaN(valor)) {
    return '0,00 MZN';
  }
  
  try {
    // Formatamos o número sem o símbolo da moeda
    const numeroFormatado = new Intl.NumberFormat('pt-MZ', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(valor));

    // Retornamos com MZN no final
    return `${numeroFormatado} MZN`;
  } catch (error) {
    console.error('Erro ao formatar moeda:', error);
    return '0,00 MZN';
  }
};

/**
 * Formata um número com as casas decimais especificadas
 * @param {number} numero - Número a ser formatado
 * @param {number} decimais - Número de casas decimais (default: 2)
 * @returns {string} Número formatado
 */
export const formatarNumero = (numero, decimais = 2) => {
  if (numero === null || numero === undefined || isNaN(numero)) {
    return '0';
  }

  try {
    return new Intl.NumberFormat('pt-MZ', {
      minimumFractionDigits: decimais,
      maximumFractionDigits: decimais
    }).format(Number(numero));
  } catch (error) {
    console.error('Erro ao formatar número:', error);
    return '0';
  }
};